import {
  VStack,
  Text,
  Checkbox,
  CheckboxIndicator,
  CheckIcon,
  CheckboxLabel,
  CheckboxIcon
} from "@gluestack-ui/themed";
import { ConfirmStoreModalBodyProps } from "./types";
import { Icon } from "@repo/core/components/core/Icon";

export const ConfirmStoreModalBody = ({
  selectedStore,
  onChangeDontShowAgain
}: ConfirmStoreModalBodyProps) => {
  return (
    <VStack width="$full" px="$3" gap="$4">
      <VStack gap="$2" justifyContent="center" alignItems="center">
        <Icon name="shop" size={60} variant="solid" color="$primary600" />
        <Text
          textAlign="center"
          color="$textLight900"
          fontWeight={600}
          size="lg"
        >
          Você está nesta loja?
        </Text>
      </VStack>

      <Text fontSize="$sm" color="$backgroundLight900" textAlign="center">
        {selectedStore?.descrLoja}
      </Text>

      <Checkbox
        gap={8}
        value="dontShowAgain"
        defaultIsChecked={false}
        mt="$2"
        onChange={onChangeDontShowAgain}
      >
        <CheckboxIndicator>
          <CheckboxIcon as={CheckIcon} />
        </CheckboxIndicator>
        <CheckboxLabel>Não mostrar novamente nessa sessão</CheckboxLabel>
      </Checkbox>
    </VStack>
  );
};
